export const QUIZ_LIMIT_QUERY_KEY = ['quiz-limit'];
